import { DataGrid, EntityDialog, HtmlContentEditor } from "@serenity-is/corelib";
import { Authorization, Config, ErrorHandling, confirmDialog } from "@serenity-is/corelib/q";
import { siteLanguageList } from "./Helpers/LanguageList";

Config.rootNamespaces.push('Fms');
EntityDialog.defaultLanguageList = siteLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";

if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;

Config.rootNamespaces.push('_Ext');

// Persist per-grid settings (column visibility/order/width, sort, quick filters) to the
// browser's localStorage so choices made via the Column Picker survive a page refresh.
// Setting the static default here applies to every DataGrid subclass app-wide, including
// grids that extend Serenity's EntityGrid directly rather than BWEntityGrid.
DataGrid.defaultPersistanceStorage = {
    getItem: key => localStorage.getItem(key),
    setItem: (key, value) => localStorage.setItem(key, value)
};

// ...but quick filters must NOT be remembered: any quick filter bar selection (or the top
// search box) should reset to empty on every page refresh / navigation. Only the column
// layout (visibility via the Column Picker, order, width, sort) persists. Patching the
// DataGrid prototype applies this to every grid app-wide, including the ones that extend
// Serenity's EntityGrid directly instead of BWEntityGrid.
const baseGridPersistanceFlags = (DataGrid.prototype as any).gridPersistanceFlags;
(DataGrid.prototype as any).gridPersistanceFlags = function () {
    const flags = (baseGridPersistanceFlags ? baseGridPersistanceFlags.call(this) : null) || {};
    flags.quickFilters = false;
    flags.quickFilterText = false;
    flags.quickSearch = false;
    return flags;
};

// When a service call fails because the user's session / anti-forgery token has expired,
// the server responds with an { Error: { Code: "NotLoggedIn" } } payload (see
// SessionExpiredResultFilter). Show a friendly message and offer to reload the page instead
// of the raw "HTTP 400 error! Check browser console for details." fallback.
let sessionExpiredPromptShown = false;
Config.notLoggedInHandler = function (options: any, response: any) {
    if (sessionExpiredPromptShown)
        return true;
    sessionExpiredPromptShown = true;

    confirmDialog(
        (response && response.Error && response.Error.Message) ||
        "Your session has expired. Please reload the page and sign in again to save your changes.",
        () => { window.location.reload(); },
        {
            title: "Session expired",
            yesButton: "Reload",
            noButton: false,
            cancelButton: "Cancel",
            onCancel: () => { sessionExpiredPromptShown = false; }
        });

    return true;
};